import classes from './ShinningText.module.css';
import type { Props } from './ShinningText.types';

export const ShinningText = ({ text, className }: Props) => {
  return <p className={`${classes.text} ${className}`}>{text}</p>;
};
